import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';

const { FiEdit, FiLinkedin, FiMessageSquare, FiArrowRight, FiCheck, FiTool } = FiIcons;

const Tools = () => {
  const { t } = useLanguage();

  const utilities = [
    { title: t.footer.letter, desc: 'Craft professional letters based on match insights.', link: '/tools/motivatiebrief', icon: FiEdit },
    { title: t.footer.trainer, desc: 'Practice role-specific questions with AI guidance.', link: '/tools/gesprek-trainer', icon: FiMessageSquare },
    { title: t.footer.linkedin, desc: 'Improve your visibility and headline impact.', link: '/tools/linkedin-check', icon: FiLinkedin },
    { title: t.footer.match, desc: 'Deep dive into job text details and requirements.', link: '/tools/vacature-match', icon: FiCheck },
  ];

  return (
    <div className="min-h-screen py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-24">
          <div className="inline-flex items-center gap-3 px-4 py-2 bg-gray-50 text-gray-400 rounded-xl text-[10px] font-black uppercase tracking-widest mb-10 border border-gray-100 shadow-sm">
            <SafeIcon icon={FiTool} /> {t.nav.tools}
          </div>
          <h1 className="text-5xl lg:text-6xl font-black text-brand-dark mb-8 tracking-tighter italic uppercase underline decoration-brand-orange decoration-4 underline-offset-8">Career Toolkit</h1>
          <p className="text-gray-500 text-lg italic font-medium leading-relaxed">
            While the AI Headhunter is our core engine, these specialized utilities support specific moments in your professional journey.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {utilities.map((tool, index) => (
            <motion.div 
              key={index} 
              initial={{ opacity: 0, y: 10 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ delay: index * 0.05 }} 
              className="bg-white rounded-[2.5rem] p-10 border border-gray-100 shadow-sm hover:shadow-2xl transition-all group relative overflow-hidden"
            >
              <div className="w-14 h-14 rounded-2xl bg-gray-50 flex items-center justify-center text-brand-dark group-hover:bg-brand-orange group-hover:text-white transition-all mb-10 shadow-sm">
                <SafeIcon icon={tool.icon} className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-black text-brand-dark mb-4 leading-tight uppercase italic group-hover:text-brand-orange transition-colors"> {tool.title} </h3>
              <p className="text-gray-400 mb-10 text-xs leading-relaxed font-bold italic"> {tool.desc} </p>
              <Link to={tool.link} className="inline-flex items-center text-brand-orange font-black text-[10px] uppercase tracking-[0.3em] hover:gap-3 transition-all"> 
                Access <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4" /> 
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tools;